































import Vue from 'vue'
import Component from 'vue-class-component'
import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed.js'

@Component<PdfViewer>({
  components: {
    VuePdfEmbed
  },
  props: {
    url: String,
    maxHeight: Number,
    showAll: Boolean,
    disableHeader: Boolean,
    emitPages: Boolean,
    defaultWidth: Number,
    page: Number,
  },
  watch: {
    url(value: string) {
      this.currentUrl = value
      if(this.currentPage !== null && this.currentPage > 1){
        this.lastPage = this.currentPage
        this.currentPage = null
      }
      else
        this.$forceUpdate()
    },
    page(value: number) {
      if(value > 0 && this.pageCount !== undefined && value <= this.pageCount){
        this.currentPage = value
      }
    }
  }
})

export default class PdfViewer extends Vue {
  /**
   * Props variables
   */
  url: string | undefined
  currentUrl: string | undefined = undefined
  showAll: boolean | undefined
  disableHeader: boolean | undefined
  emitPages: boolean | undefined
  page: number | undefined = undefined
  currentPage: number | null = null
  lastPage: number | null = null
  defaultWidth: number | undefined
  maxHeight: number | undefined
  scale: number = 100
  pageCount: number | undefined = 1
  isLoading: boolean = true
  $refs!: {
    pdfRef: HTMLFormElement
  }
  /**
   * Lifecycle
   */
  mounted() {
    if (this.url !== undefined) this.currentUrl = this.url
    if (this.showAll === undefined) this.showAll = false
    if (this.disableHeader === undefined) this.disableHeader = false
    if (this.emitPages === undefined) this.emitPages = false
    if (this.maxHeight === undefined) this.maxHeight = 800
    if(!this.showAll && this.page !== undefined) this.currentPage = 1
  }

  /**
   * Methods
   */
  async handleDocumentRender() {
    this.isLoading = false
    var ref = this.$refs.pdfRef
    this.pageCount = ref.pageCount
    if (this.defaultWidth === undefined)
      this.defaultWidth = ref.getPageDimensions()[0]
    if(this.lastPage && this.pageCount) {
      if(this.pageCount < this.lastPage)
        this.currentPage = this.pageCount
      else
        this.currentPage = this.lastPage
    }
    if(this.emitPages) {
      this.$emit("setPage",this.currentPage)
      this.$emit("setPagecount",this.pageCount)
    }
    this.lastPage = null
  }
  async downloadDocument() {
    window.open(this.url);
  }
}
